import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BuyeasySupplierTprmTranslations = wrapTranslationsSchema({
	name: 'BuyEasySupplierTprmTranslations',
	title: 'TPRM Section Translations',
	sanityId: 'buyeasy-supplierTprm',
	fields: {
		tprmSectionTitle: 'THIRD PARTY RISK INFORMATION',
		tprmLinkPowerBi:
			'https://app.powerbi.com/groups/me/apps/4039e03f-8776-46be-aac0-8a0a872c8931/reports/891ecb56-22e3-429f-bbc6-0abc54469720/8d37c344a4e600078675?experience=power-bi',
		tprmLinkMore: 'More Information on TPRM',
		takedaLocation: 'Takeda Location',
		sourceSystem: 'Source System',
		thirdPartyLocation: '3rd Party Location',
		cpCode: 'CP Code',
		overallRiskScore: 'Overall Risk Score',
		erExpirationDate: 'ER Expiration Date',
		tprmReviewStatus: 'TPRM Review Status',
		engagementRequestId: 'Engagement ID',
		requestId: 'Request ID',
		noTprm: 'no TPRM Information available',
		noTakedaLocationSelected: 'No Takeda location selected',
		emptyAriba: 'Select at least one Takeda Location to see any TPRM related data',
		emptyApex: 'Select at least one Takeda Location to see any TPRM related data',
		emptyApexNoLocations: 'No Locations available. TPRM data cannot be displayed',
		emptyAribaNoLocations: 'No Locations available. TPRM data cannot be displayed',
		informationInPowerBi: 'Third Part Risk Information in PowerBI',
		takedaLocationsAriba: 'Takeda Locations where Ariba Risk is Live',
		moreInformationOnTprm: 'More Information on TPRM',
		takedaLocationsApex: 'Takeda Locations where Apex is Live',
		reviewStatus: 'Review Status',
		category: 'Category',
		categoryLo: 'Category L0',
		notSelected: 'not selected',
		title: 'You’re browsing for purchasing org',
		country: 'Country',
		companyCode: 'Company Code',
		purchasingOrg: 'Purchasing Org.',
	},
});
